import * as React from 'react';
import PropTypes from 'prop-types';
import tokens from '../../Tokens/tokens';
const { colors, spacing } = tokens;

const IconSearch = ({ title, titleId, ...props }) => {
    const sizeArray = Object.entries(spacing.icons);
    const colorArray = Object.entries(colors.icons);
    const sizeOptions = new Map(sizeArray);
    const displaySize = sizeOptions.get(props.size);
    const colorOptions = new Map(colorArray);
    const displayColor = colorOptions.get(props.color);
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            viewBox='0 0 16 16'
            fill={props.color && displayColor}
            aria-hidden={!title}
            role={title ? 'img' : null}
            width={props.size && displaySize}
            height={props.size && displaySize}
            aria-labelledby={titleId}
            {...props}
        >
            {title ? <title id={titleId}>{title}</title> : null}
            <path d='M6 12a6 6 0 116-6 6 6 0 01-6 6zM6 2a4 4 0 104 4 4 4 0 00-4-4z' />
            <path d='M15 16a1 1 0 01-.71-.29l-5.4-5.41a1 1 0 011.41-1.41l5.41 5.4a1 1 0 010 1.42A1 1 0 0115 16z' />
            <path d='M6 12a6 6 0 116-6 6 6 0 01-6 6zM6 2a4 4 0 104 4 4 4 0 00-4-4z' />
            <path d='M15 16a1 1 0 01-.71-.29l-5.4-5.41a1 1 0 011.41-1.41l5.41 5.4a1 1 0 010 1.42A1 1 0 0115 16z' />
        </svg>
    );
};

IconSearch.propTypes = {
    title: PropTypes.string,
    titleId: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'md']),
    color: PropTypes.oneOf(['primaryBlue', 'secondaryBlue', 'darkGrey', 'white']),
};
IconSearch.defaultProps = {
    size: 'sm',
    color: 'darkGrey',
    focusable: false,
};
export default IconSearch;
